import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/es/disclaimer")({
  head: () => ({
    meta: [
      { title: "Aviso Legal y Exención de Responsabilidad — Picamini.online" },
      {
        name: "description",
        content: "Aviso legal y exención de responsabilidad de Picamini.online.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/es/aviso-legal" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/disclaimer" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/aviso-legal" },
    ],
  }),
  component: EsDisclaimerPage,
});

function EsDisclaimerPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="es" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl font-extrabold text-foreground">Aviso Legal y Exención de Responsabilidad</h1>
        <p className="text-sm text-muted-foreground">Última actualización: Septiembre 2026</p>

        <div className="surface-card p-6 sm:p-8 rounded-2xl bg-card border space-y-4 text-sm sm:text-base text-muted-foreground leading-relaxed">
          <h2 className="text-xl font-bold text-foreground">1. Exención de Responsabilidad General</h2>
          <p>
            Picamini.online proporciona herramientas web interactiva "tal cual" y según disponibilidad. Aunque nos esforzamos por garantizar la precisión y la imprevisibilidad matemática en las selecciones, no garantizamos que el servicio sea ininterrumpido.
          </p>

          <h2 className="text-xl font-bold text-foreground">2. Uso en Decisiones Críticas</h2>
          <p>
            Nuestras ruletas y sorteos están pensados para el entretenimiento, la dinamización del aula y la organización de grupos. No deben ser utilizados para sorteos regulados o apuestas legales sin la auditoría correspondiente.
          </p>

          <h2 className="text-xl font-bold text-foreground">3. Enlaces a Terceros</h2>
          <p>
            Picamini.online puede contener enlaces a sitios web de terceros (como Eduzuma.com). No somos responsables del contenido o políticas de privacidad de dichos sitios externos.
          </p>
        </div>
      </main>

      <SiteFooter lang="es" />
    </div>
  );
}
